import { configureStore } from '@reduxjs/toolkit';
import loadingSlice from '../pages/Loading/loadingSlice';
import userProfileSlice from '../pages/UserProfile/userProfileSlice';

export const store = configureStore({
  reducer: {
    loading: loadingSlice.reducer,
    userProfile: userProfileSlice.reducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
